import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BaseForm from './BaseForm';
import confirmModal from '../confirmModal';
import { t } from '../../../modules/infra/i18n';

class EditForm extends Component {
  static propTypes = {
    deleteButton: PropTypes.func.isRequired,
    saveButton: PropTypes.func.isRequired,
    cancelButton: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = { active: 0, values: this.props.initialValues };

  componentWillReceiveProps(nextProps) {
    if (this.props.initialValues !== nextProps.initialValues) {
      this.setState({ values: nextProps.initialValues });
    }
  }

  onSubmit = async (values) => {
    await this.props.onSubmit(values);
    this.setState({ values });
  };

  onTabChange = (index, pristine, reset, submit) => {
    if (pristine) {
      this.setState({ active: index });
      return;
    }

    confirmModal(
      {
        title: t('common:edit_form.unsaved_changes_title'),
        message: t('common:edit_form.unsaved_changes_message'),
        type: 'yesno',
        confirmButtonText: t('common:edit_form.yes_button'),
        negativeButtonText: t('common:edit_form.no_button'),
      },
      () => {
        submit();
        this.setState({ active: index });
      },
      () => {
        this.setState({ active: index });
        reset();
      }
    );
  };

  renderControls = (pristine, submitting) => (
    <div className="u-bg-white u-position-relative">
      <div className="c-separator u-mv" />
      <div className="u-text-right u-mh u-pb">
        {this.props.deleteButton()}
        {this.props.cancelButton()}
        {this.props.saveButton(pristine, submitting, this.state)}
      </div>
    </div>
  );

  render() {
    return (
      <BaseForm
        {...this.props}
        active={this.state.active}
        controls={this.renderControls}
        onTabChange={this.onTabChange}
        onSubmit={this.onSubmit}
        initialValues={this.state.values}
      />
    );
  }
}

export default EditForm;
